import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderGroupOutline = createIcon({
  displayName: 'FolderGroupOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19,6.94h-6.471c-0.331,0 -0.641,-0.164 -0.827,-0.438l-1.405,-2.065c-0.186,-0.273 -0.495,-0.437 -0.826,-0.437h-4.471c-1.105,0 -2,0.895 -2,2v12c0,1.105 0.895,2 2,2h14c1.105,0 2,-0.895 2,-2v-9.06c0,-1.104 -0.895,-2 -2,-2Z"></path>
        <path d="M10.833,10.583v1.168c0,0.322 0.261,0.583 0.583,0.583h1.168c0.322,0 0.583,-0.261 0.583,-0.583v-1.168c0,-0.322 -0.261,-0.583 -0.583,-0.583h-1.168c-0.322,0 -0.583,0.261 -0.583,0.583Z"></path>
        <path d="M8.005,15.249v1.168c0,0.322 0.261,0.583 0.583,0.583h1.168c0.322,0 0.583,-0.261 0.583,-0.583v-1.168c0,-0.322 -0.261,-0.583 -0.583,-0.583h-1.168c-0.322,0.001 -0.583,0.261 -0.583,0.583Z"></path>
        <path d="M13.661,15.249v1.168c0,0.322 0.261,0.583 0.583,0.583h1.168c0.322,0 0.583,-0.261 0.583,-0.583v-1.168c0,-0.322 -0.261,-0.583 -0.583,-0.583h-1.168c-0.322,0.001 -0.583,0.261 -0.583,0.583Z"></path>
        <path d="M13.66,15.55h-3.32"></path>
        <path d="M9.79,14.67l1.57,-2.35"></path>
        <path d="M12.73,12.3l1.5,2.37"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderGroup: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderGroupTwoTone} {...props} />

  return <CustomIcon as={FolderGroupOutline} {...props} />
}

export default memo(FolderGroup)
